module.exports = __webpack_public_path__ + "img/portrait-073.dac4ed9c.jpg";